import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Paragraph} from '../Paragraph'
import { renderParagraphs } from '../utils'
import {withPrefix} from 'gatsby-link'
import {ModalImage} from '../ModalImage'
import Img from 'gatsby-image'

import './info-block.css'
const paragraphMarginBottomStyle = {marginBottom : 20};

class InfoBlock extends Component {

  renderTitleAsLink(title, href) {

    if (title == null) {
      return null;
    }

    return (
      <a href = {href} className="link-title" target="_blank">
        {title}
      </a>
    );
  }

  renderTitle(title) {

    if (title == null) {
      return null;
    }

    return (
      <div className="info-block-title">
        {title}
      </div>
    );
  }

  renderImg(src) {
    return (
      <a >
      <Img
        className="info-block-img"
        sizes={this.props.sizes}></Img>
      </a>);
  }

  renderImgAsLink(src, href) {
    return (
      <a href={href} target="_blank">
        <Img
          className="info-block-img"
          sizes={this.props.sizes}></Img>
      </a>
    );
  }

  render () {
    let data = this.props.data;
    let title = data.isLink ? this.renderTitleAsLink(data.title, data.href) : this.renderTitle(data.title);
    let description = renderParagraphs(data.description, this.props.descriptionStyleMod);

    let img;

    if (this.props.hasModalImage) {
      img = <ModalImage sizes={this.props.sizes} src={data.imgSrc} description = {data.description[0].text}></ModalImage>
    } else {
      img = data.isLink ? this.renderImgAsLink(data.imgSrc, data.href) : this.renderImg(data.imgSrc);
    }

    return (
      <div className="info-block">
        {img}
        {title}
        {description}
      </div>
    );
  }
}


export default {InfoBlock}



// WEBPACK FOOTER //
// ./src/components/InfoBlock/index.js